import React, { useState } from "react";
import { View, StyleSheet } from "react-native";

import Screen from "../components/Screen";
import { AppForm, AppFormField, SubmitButton } from "../components/forms";
import useApi from "../hooks/useApi";
import authApi from "../api/auth";

function ResetPasswordScreen({ navigation }) {
    const [message, setMessage] = useState();
    const resetPasswordApi = useApi(authApi.resetPassword);

    const handleSubmit = async (email) => {
        const response = await resetPasswordApi.request(email.email);
        if (response.ok) {
            setMessage("Reset instructions sent to " + email.email + "\n\n Please check your email");
        } else {
            setMessage("Error Resetting Email");
        }
    };

    return (
        <Screen title={"Reset Password"} navigation={navigation} message={message} setMessage={setMessage}>
            <AppForm
                initialValues={{
                    email: "",
                }}
                onSubmit={handleSubmit}
            >
                <View style={styles.form}>
                    <AppFormField
                        autoCapitalize="none"
                        autoCorrect={false}
                        icon="email"
                        keyboardType="email-address"
                        name="email"
                        placeholder="Email"
                        textContentType="emailAddress"
                    />
                    <SubmitButton title="Reset Password" width={30} />
                </View>
            </AppForm>
        </Screen>
    );
}

const styles = StyleSheet.create({
    form: {
        padding: 20,
    },
});

export default ResetPasswordScreen;
